export default __webpack_public_path__ + "static/media/plbgcircle.90411a13.png";